import { IMeetingReportsSearchParams, IReportsSearchParams } from '../../page/page-storage/reports/reports.types';
import { IMeetingSimple } from '../../resource/meeting-simple/meeting-simple.types';
import { IUser } from '../../resource/user/user.types';
import { IApiRequestConfig } from '../api.types';

export const fetchMeetingReportsApi = (
  meetingId: IMeetingSimple['id'],
  params?: IMeetingReportsSearchParams,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getMeetingReports',
  uri: 'json',
  action: `reports/meetings/${meetingId}`,
  method: 'get',
  v2: true,
  params,
});

export const fetchUserReportsApi = (
  userId: IUser['id'],
  params?: IReportsSearchParams,
): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getUserReports',
  uri: 'json',
  action: `reports/users/${userId}`,
  method: 'get',
  v2: true,
  params,
});
